#import "./SentenceDetails.graphql"
query HaftarahSentencesQuery($haftarah: ID!) {
  haftarahSentences(haftarah: $haftarah) {
    ...sentenceDetails
  }
}
